import { log } from '@/log'
import { Context } from '@/models/order-history/status/context/context'
import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import { CreateOrderStatusViewModelCommand } from '@spa/components/organisms/mypage/order/model/order-status-view/create-command'
import { orderStatusViewKinds } from '@spa/components/organisms/mypage/order/model/order-status-view/kind'

/**
 * @internal モジュールの外部からはcreateOrderStatusViewModelを利用すること
 */
export class ForDefaultPaymentMethod extends CreateOrderStatusViewModelCommand<Context> {
  shouldApply(_context: Context): _context is Context {
    return true
  }
  createViewModel(
    context: Pick<Context, 'engineStatus'>
  ): OrderStatusViewModel {
    switch (context.engineStatus) {
      case 'payment-requested':
        return orderStatusViewKinds.beforePayment
      case 'payment-done':
        return orderStatusViewKinds.paymentDone
      case 'shipment-preparation':
        return orderStatusViewKinds.beforePreparingShipping
      case 'shipment-suspend-preparation':
        return orderStatusViewKinds.shipmentSuspendPreparation
      case 'shipment-started':
        return orderStatusViewKinds.preparingShipping
      case 'shipment-suspend-delivery':
        return orderStatusViewKinds.shipmentSuspendDelivery
      case 'shipment-undeliverable':
        return orderStatusViewKinds.shipmentUndeliverable
      case 'shipment-delivering':
        return orderStatusViewKinds.delivering
      case 'cancel':
        return orderStatusViewKinds.canceled
      case 'payment-error':
      case 'payment-fatal-error':
        return orderStatusViewKinds.errorOccurred
      default:
        log.error(`unexpected order status ${context.engineStatus}`)

        return orderStatusViewKinds.others
    }
  }
}
